import { createFileRoute } from "@tanstack/react-router";

import { ExportPage } from "~/pages/settings/export/export.page";

export const Route = createFileRoute("/_app/settings/_organization/export")({
  component: ExportPage,
});
